import { render, staticRenderFns } from "./dialog-modify-base.vue?vue&type=template&id=b5ea001a&scoped=true"
import script from "./dialog-modify-base.vue?vue&type=script&lang=js"
export * from "./dialog-modify-base.vue?vue&type=script&lang=js"
import style0 from "./dialog-modify-base.vue?vue&type=style&index=0&id=b5ea001a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ea001a",
  null
  
)

export default component.exports